import { Component, Input, ViewChild, Output, EventEmitter, HostListener } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

/**
 * @export
 * @class MultiSelectFilterComponent
 */
@Component({
  selector: 'app-multi-select-filter',
  template: require('./multi-select-filter.component.html'),
  styles: [require('./multi-select-filter.component.scss')],
})

export class MultiSelectFilterComponent {
  @ViewChild('dropdown', { static: false }) dropdown: NgbDropdown;

  @Input() items: string[] = [];
  @Input() qa: string;
  @Input() shouldTranslate: boolean;

  @Input()
  public set selected(items: string[]) {
    this.selectedItems = {};

    if (items) {
      items.forEach(item => {
        this.selectedItems[item] = true;
      });
    }

    this.mapToSelectedValues();
    this.setLabel();
  }

  @Output() selectionChanged = new EventEmitter();

  private selectedValues = [];
  public selectedItems = {};
  public label = ['All'];

  @HostListener('document:keyup', ['$event'])
  /**
   * Closes select when Escape key pressed
   */
  public onKeyUp(ev: KeyboardEvent): void {
    if (ev.key === 'Escape') {
      this.dropdown.close();
    }
  }

  public trackByIndex(index: number): number {
    return index;
  }

  /**
   * Handles click on apply button
   * Emits selected items to the parent component
   * @memberof MultiSelectFilterComponent
   */
  public onClick(): void {
    this.mapToSelectedValues();
    this.setLabel();

    this.dropdown.close();
    this.selectionChanged.emit(this.selectedValues);
  }

  private mapToSelectedValues(): void {
    this.selectedValues = [];

    for (const itemKey in this.selectedItems) {
      if (this.selectedItems[itemKey]) {
        this.selectedValues = [...this.selectedValues, itemKey];
      }
    }
  }

  private setLabel(): void {
    if (this.items.length === this.selectedValues.length || this.selectedValues.length === 0) {
      this.label = ['All'];
    } else {
      this.label = this.selectedValues;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/multi-select-filter/multi-select-filter.component.ts